import * as FileSystem from 'expo-file-system';
import { FileSystemUploadType } from "expo-file-system";
import { accessToken } from "../components/core/auth-service/auth-service";
import { ErrorResponseWrapper } from "../model/ErrorResponseWrapper";
import getConfig from '../environment';
import { Platform } from 'react-native';
import { ErrorFileUploadResponseWrapper } from '../model/ErrorFileUploadResponseWrapper';

const FILE_UPLOAD_API = getConfig()?.fileUploadApi;

export async function uploadFile(fileUri: string, fileName: string, fileUploadType: string, currentLanguage: string, orderScenario: string, paymentTerm: string, notes: string , purchaseOrder: string, customerUid: string) {
  const url = `${FILE_UPLOAD_API}/${fileUploadType}`;
  let res;
  if (Platform.OS === 'web') {
    const formData = new FormData();
    formData.append('file', await createBlobFromURI(fileUri), fileName);
    if(fileUploadType === 'orders/xls') {
      formData.append('orderType', orderScenario);
      if(paymentTerm) {
        formData.append('paymentTerm', paymentTerm);
      }
      formData.append('notes', notes);
      formData.append('purchaseOrder', purchaseOrder);
    }
    formData.append('customerUid', customerUid);
    res = uploadFileWeb(url, formData, fileUploadType, currentLanguage)
  }
  else {
    const nativeFormData = fileUploadType === 'orders/xls' ? {
      orderType: orderScenario,
      ...(paymentTerm && { paymentTerm: paymentTerm }),
      notes: notes,
      purchaseOrder: purchaseOrder,
      customerUid: customerUid,
    } : undefined;
    res = uploadFileNative(url, fileUri, fileUploadType, currentLanguage, nativeFormData)
  }
  return res
    .catch((errorResponse) => {
      console.log('wrappovan = ', errorResponse instanceof ErrorResponseWrapper);
      if (errorResponse instanceof ErrorResponseWrapper || errorResponse instanceof ErrorFileUploadResponseWrapper) {
        return errorResponse.getErrorMessages();
      } else {
        return new Promise<string[]>((resolve) => { [{ status: 'Communication Failure', detail: errorResponse.message }] })
      }
    });
}

async function uploadFileWeb(url: string, formData: FormData, uploadType: string, currentLanguage: string) {
  return fetch(url, {
    method: "POST",
    body: formData,
    headers: {
      'Accept': 'application/json',
      'Accept-Language': currentLanguage,
      'Authorization': `Bearer ${await accessToken()}`
    }
  }).then(response => {
    console.log('the response itself is =', response);
    if (response.ok) {
      return uploadType === 'orders/xls' ? response.json() : response;
    } else {
      throw new ErrorResponseWrapper(response);
    }
  })
  .then(res => {
    console.log('respones in action = ', res);
    return({
      status: "success",
      detail: uploadType === 'orders/xls' ? res.detail : 'Success message'
    })
  })
}

async function uploadFileNative(url: string, localUri: string, currentLanguage: string, uploadType: string, formData: Record<string, string> | undefined) {
  return FileSystem.uploadAsync(url, localUri, {
    uploadType: FileSystemUploadType.MULTIPART,
    httpMethod: "POST",
    ...(formData && {parameters: formData}),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
      'Accept-Language': currentLanguage,
      'Authorization': `Bearer ${await accessToken()}`
    },
    fieldName: "file"
  }).then(response => {
    console.log('the response itself is =', response);
    if (response.status == 201) {
      return response.json();
    } else {
      throw new ErrorResponseWrapper(response);
    }
  })
  .then(res => {
    console.log('respones in action = ', res);
    return({
      status: "success",
      detail: uploadType === 'orders/xls' ? res.detail : 'Success message'
    })
  })
}

async function createBlobFromURI(dataURI: string) {
  const binary = await getBinary(dataURI), array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: 'file/txt' });
};

async function getBinary(dataURI: string) {
  if (Platform.OS === 'web') {
    return atob(dataURI.split(',')[1] || '')
  }
  else {
    const bin = await FileSystem.readAsStringAsync(dataURI, { encoding: FileSystem.EncodingType.UTF8 })
    return atob(bin)
  }
};

export function xlsTemplateUrl(currentLanguage: string = 'en') {
  return `${FILE_UPLOAD_API}/templates/${currentLanguage}/order_xls_upload.xlsx`;
}  
